export default [
  function () {
    return function (isValid, path, message) {
      this.isValid = isValid;
      this.path = path;
      this.message = message;
    };
  },
];
